import { useEffect, useRef } from "react";

// 창(모달·서랍) 닫기 공통 처리.
// - 바깥(배경) 클릭: 누른 곳과 뗀 곳이 모두 배경일 때만 닫는다 — 입력칸에서 글자를 끌어 선택하다 바깥에서 떼면 닫히지 않게.
// - Esc: 여러 창이 겹치면 맨 위(나중에 열린) 창만 닫는다.
const stack = [];

export function useDismiss(onClose, { enabled = true } = {}) {
    const close = useRef(onClose);
    close.current = onClose;
    const down = useRef(false);
    useEffect(() => {
        if (!enabled) return undefined;
        const me = { close: () => close.current() };
        stack.push(me);
        const onKey = (e) => { if (e.key === "Escape" && stack[stack.length - 1] === me) me.close(); };
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("keydown", onKey);
            const i = stack.indexOf(me);
            if (i >= 0) stack.splice(i, 1);
        };
    }, [enabled]);
    return {
        onMouseDown: (e) => { down.current = e.target === e.currentTarget; },
        onClick: (e) => {
            if (enabled && down.current && e.target === e.currentTarget) close.current();
            down.current = false;
        },
    };
}

// div·tr 같은 요소를 키보드로도 누를 수 있게 한다(Enter·Space).
export const clickable = (fn) => ({
    role: "button",
    tabIndex: 0,
    onClick: fn,
    onKeyDown: (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fn(e); } },
});
